import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=4b8f4c38&scoped=true&"
import script from "./ClassList.vue?vue&type=script&lang=js&"
export * from "./ClassList.vue?vue&type=script&lang=js&"
import style0 from "./ClassList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClassList.vue?vue&type=style&index=1&id=4b8f4c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f4c38",
  null
  
)

export default component.exports